module.exports = __webpack_public_path__ + "officialStatic/img/wx-spec-shengqian.b48f0cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/wx-spec-shengqian.png
// module id = EB3a
// module chunks = 0